<div class="row">
    <div class="col-lg-6 offset-sm-3 card medium-screen-card mt-5 mb-5">
       <div class="p-4 mb-2">
          <div *ngIf="isProcessing">
             <h4 class="text-center">{{ 'GRANTING_PERMISSIONS' | translate }}</h4>
             <div class="text-center">
                <div style="position: relative; height: 6em;">
                   <ngx-spinner [fullScreen]="true" type="none" [template]="spinnerTemplate" size="medium"></ngx-spinner>
                </div>
             </div>
          </div>
 
          <div *ngIf="!isProcessing">
             <div *ngIf="isSuccess">
                <h4 class="text-center">{{ 'PERMISSION_GRANTED' | translate }}</h4>
                <div class="text-center">
                   <!-- inline success icon -->
                    <div class="inline-success-icon" aria-hidden="true">
                           <img src='assets/images/checkboxright.png'/>
                    </div>
                </div>
                <div class="text-center">
                   <span>{{ 'PERMISSION_GRANTED' | translate }}</span>
                   <br><span>{{ 'NOW_CONTRACTS_ARE_ACCESSIBLE' | translate }}</span>
                </div>
                <div class="text-center">
                   <button class="btn btn-primary mt-2" (click)="signIn()">
                      <span>{{ 'SIGN_IN' | translate }}</span>
                   </button>
                </div>
             </div>
 
             <div *ngIf="!isSuccess">
                <h4 class="text-center">{{ 'ERROR_GRANTING_PERMISSIONS' | translate }}</h4>
                <div class="text-center">
                   <img src='assets/images/checkboxwrong.png'/>
                </div>
                <!-- <app-alert [dismissAfter]="0"></app-alert> -->
                <div class="text-center">
                   <button class="btn btn-outline-primary mt-2" (click)="goToHome()">
                      <span>{{ 'BACK' | translate }}</span>
                   </button>
                </div>
             </div>
          </div>
       </div>
    </div>
 </div>
